/*======================================================================================================================
  * Bluebell: src/app/state/postpro/postpro.actions.ts
  * Last Edited: 14/07/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { createAction, props } from '@ngrx/store';
import {
  Postpro,
  PostproAvailableVariables,
  AllPostproType,
  PostproReference, PlotOverlayClipping, PlotOverlaySide,
} from '@state/postpro/postpro.interfaces';


const name = (action: string) => `[Postpro] ${action}`;

/**
 * References
 */
export const deselectPostproVariable = createAction(
  name('Deselect Variable'),
  props<{postproType: AllPostproType, variable: string, camera?: string }>()
);
export const selectPostproVariable = createAction(
  name('Select Variable'),
  props<{ postproType: AllPostproType, variable: string, camera?: string, casesChanged?: boolean }>()
);
export const cameraClick = createAction(name('Camera Click'), props<{ camera: string }>());
export const setSelectedCameras = createAction(name('Set Selected Cameras'),  props<{ cameras: string[] }>());
export const toggleAllowMultipleCameras = createAction(name('Toggle Allow Multiple Cameras'));

export const setPlotOverlayReferences = createAction(
  name('Set Plot Overlay References'),
  props<{ plotOverlayReferences: PostproReference[] }>()
);
export const clearPlotOverlayReferences = createAction(name('Clear Plot Overlay References'));
export const setPlotOverlayClipping = createAction(
  name('Set Plot Overlay Clipping'),
  props<{ plotOverlayClipping: PlotOverlayClipping }>()
);
export const setPlotOverlaySide = createAction(
  name('Set Plot Overlay Side'),
  props<{ plotOverlaySide: PlotOverlaySide }>()
);
export const clearPlotOverlaySettings = createAction(
  name('Clear Plot Overlay Settings'))
;

export const loadLICReferences = createAction(
  name('Load LIC References'),
  props<{ postproType: AllPostproType, camera?: string }>()
);
export const loadLICReferencesSuccess = createAction(
  name('Load LIC References Success'),
  props<{ licReferences: PostproReference[] }>()
);
export const loadLICReferencesFailure = createAction(name('Load LIC References Failure'));
export const clearLICReferences = createAction(name('Clear LIC References'));


export const loadPostproReferences = createAction(
  name('Load References'),
  props<{ variable: string, postproType: AllPostproType, cases: string[], camera?: string }>()
);
export const loadPostproReferencesSuccess = createAction(
  name('Load References Success'),
  props<{ variable: string, references: Postpro[], camera?: string }>()
);
export const loadPostproReferencesFailure = createAction(name('Load References Failure'), props<{ variable: string, camera?: string }>());
export const reselectLoadedReferences = createAction(name('Reselect Loaded References'), props<{ variable: string, camera?: string }>());

/**
 * Misc
 */

export const listPostproAvailableVariables = createAction(
  name('List Available Variables'),
  props<{ uuids: string[] }>()
);
export const listPostproAvailableVariablesSuccess = createAction(
  name('List Available Variables Success'),
  props<{ availableVariables: PostproAvailableVariables }>()
);
export const listPostproAvailableVariablesFailure = createAction(name('List Available Variables Failure'));
export const clearPostproAvailableVariables = createAction(name('Clear Available Variables'));

/**
 * Component Actions
 */

export const postproViewerClosed = createAction(name('Postpro Viewer Closed'));
export const selectGridOverlay = createAction('Select Grid Overlay', props<{ gridOverlay: string }>());
